export enum LoginErrorCodeTypes {
    USER_NOT_FOUND = "USER_NOT_FOUND",
    ORG_LOGIN_NOT_SUPPORTED = "ORG_LOGIN_NOT_SUPPORTED",
    SECURITY_CHECK_FAILURE = "SECURITY_CHECK_FAILURE",
    LOGIN_FAILURE = "LOGIN_FAILURE",
    INVITATION_INVALID = "INVITATION_INVALID",
    INVITATION_EXPIRED = "INVITATION_EXPIRED",
    INVITATION_USED = "INVITATION_USED",
    SESSION_TIMEOUT = "SESSION_TIMEOUT"
}